import { Children, ReactElement, ReactNode, cloneElement } from 'react';
import { isFragment } from 'react-is';

import Indexable from '../../types/DataStructure/Indexable';
import surrogateId from '../string/surrogateId';

type WrapperMethod = (
    child: ReactNode,
    key: string | number | undefined,
    index: number
) => ReactElement | null;

const keyForChild = (child: ReactNode): string | undefined => {
    if (typeof child !== 'object') {
        return surrogateId();
    }

    return (child as Indexable).key;
};

const wrapChild = (child: ReactNode, wrapper: WrapperMethod, index: number) => {
    if (!child) {
        return null;
    }

    return wrapper(child, keyForChild(child), index);
};

const wrapChildren = (
    children: Array<Exclude<ReactNode, boolean | null | undefined>>,
    wrapper: WrapperMethod
): ReactNode | Array<ReactNode> =>
    children.map((child, index) => {
        if (isFragment(child)) {
            return cloneElement(child, {
                ...child.props,
                children: wrapChildren(
                    Children.toArray(child.props.children),
                    wrapper
                ),
            });
        }

        return wrapChild(child, wrapper, index);
    });

export default wrapChildren;
